import { HostStorage } from '@ftr/contracts/regional-api'
import { AbstractClassBuilder } from '@ftr/foundation'

export class HostStorageBuilder extends AbstractClassBuilder<HostStorage> {
  constructor() {
    super(HostStorage, {
      bytes: 1.1e12,
    })
  }
}
